const basePath = process.env.NEXT_PUBLIC_BASE_PATH || "";

// Routes src through our own image proxy (pages/api/image-proxy.ts) rather
// than Next's built-in /_next/image optimizer: this app is multi-tenant with
// an unbounded set of tenant image hosts, which Next's static
// images.remotePatterns allowlist can't represent - the proxy validates the
// host dynamically per request/tenant instead.
//
// Addressed as /image-proxy (rewritten in next.config.js), not /api/image-proxy:
// in a deployment /api/* is routed to the backend and would 404.
export const getOptimizedImageUrl = (
  src?: string,
  width = 1920,
  quality = 75,
) => {
  if (!src) return src;

  return `${basePath}/image-proxy?url=${encodeURIComponent(src)}&w=${width}&q=${quality}`;
};
